"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleCard = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const elements_1 = require("./elements");
const ArticleCard = (_a) => {
    var { title, thumbnail, url } = _a, props = __rest(_a, ["title", "thumbnail", "url"]);
    return (react_1.default.createElement(elements_1.StyledWrapper, Object.assign({ as: "a", direction: "vertical", href: url, target: "_blank", thumbnail: thumbnail }, props),
        react_1.default.createElement(elements_1.StyledContent, null,
            react_1.default.createElement(elements_1.StyledDetails, { gap: 3 },
                react_1.default.createElement(elements_1.StyledTitle, { clamp: true }, title),
                react_1.default.createElement(Icon_1.Icon, { css: {
                        color: '#999999',
                        transform: 'rotate(270deg)',
                    }, name: "arrowDown" })))));
};
exports.ArticleCard = ArticleCard;
